import { render, staticRenderFns } from "./CtintMainTabSub.vue?vue&type=template&id=26b5123e&"
import script from "./CtintMainTabSub.vue?vue&type=script&lang=js&"
export * from "./CtintMainTabSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports